import React from 'react';
import { buildLocationCoverage } from '../utils/locationAssignmentUtils';
import './LocationCoveragePanel.css';

const NameList = ({ items, emptyLabel }) => {
  if (!items.length) {
    return <p className="location-coverage-panel__empty">{emptyLabel}</p>;
  }

  return (
    <ul className="location-coverage-panel__list">
      {items.map((item) => (
        <li key={item.id}>{item.name || item.firstName || 'Untitled'}</li>
      ))}
    </ul>
  );
};

const LocationCoveragePanel = ({ location, staff = [], services = [] }) => {
  const coverage = buildLocationCoverage({ location, staff, services });

  return (
    <div className="location-coverage-panel" aria-label={`Coverage for ${location.name}`}>
      <div className="location-coverage-panel__grid">
        <section className="location-coverage-panel__section">
          <h3 className="location-coverage-panel__heading">Works at this location</h3>
          <p className="location-coverage-panel__meta">
            {coverage.staffAtLocation.length} team member{coverage.staffAtLocation.length === 1 ? '' : 's'}
          </p>
          <NameList
            items={coverage.staffAtLocation}
            emptyLabel="No team members are assigned to work here yet. Edit an employee profile to add this location."
          />
        </section>

        <section className="location-coverage-panel__section">
          <h3 className="location-coverage-panel__heading">Services offered here</h3>
          <p className="location-coverage-panel__meta">
            {coverage.servicesAtLocation.length} service{coverage.servicesAtLocation.length === 1 ? '' : 's'}
          </p>
          <NameList
            items={coverage.servicesAtLocation}
            emptyLabel="No services are offered at this location yet. Edit a service and choose this location."
          />
        </section>
      </div>

      {coverage.unbookableServices.length > 0 ? (
        <div className="location-coverage-panel__warning" role="status">
          <strong>Booking gaps</strong>
          <p>
            These services are offered here, but none of their assigned staff work at this location:
          </p>
          <ul className="location-coverage-panel__list">
            {coverage.unbookableServices.map(({ service }) => (
              <li key={service.id}>{service.name || 'Untitled service'}</li>
            ))}
          </ul>
          <p className="location-coverage-panel__hint">
            Assign staff to the service in Manage Services, and make sure those staff also work at this location.
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default LocationCoveragePanel;
